import { cn } from '@lair-finance/util'
import { Link } from 'react-router-dom'

export function MenuLink({ className, children, to, active }: { className?: string; children: React.ReactNode; to: string; active?: boolean }) {
  return (
    <Link
      className={cn(
        'flex items-center h-[48px] px-3 rounded-[8px] bg-greyscale-600 hover:bg-greyscale-500 text-greyscale-300 hover:text-greyscale-100 typo-new-label-2',
        { 'text-greyscale-100 bg-greyscale-500': active },
        className,
      )}
      to={to}
    >
      {children}
    </Link>
  )
}

export function MenuItem({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div className={cn('flex items-center h-[48px] px-3 rounded-[8px] bg-greyscale-600 text-greyscale-300 typo-new-label-2', className)}>
      {children}
    </div>
  )
}
